<div class="row">
  <div class="col-10" (click)="remove()">
    <div *ngIf="title"
         [class]="options.titleClass"
         [attr.aria-label]="title"
         class="custom-title">
      {{ title }}
    </div>
    <div *ngIf="message && options.enableHtml" role="alert" aria-live="polite"
         class="custom-message"
         [class]="options.messageClass" [innerHTML]="message">
    </div>
    <div *ngIf="message && !options.enableHtml" role="alert" aria-live="polite"
         class="custom-message"
         [class]="options.messageClass" [attr.aria-label]="message"> 
      <small _ngcontent-dyn-c7="" class="text-muted" [innerHTML]="notificationPackage.config.payload?.notificationMessage"></small>
    </div>
  </div>

  <div class="col-2 colorG noPaddingLeft"> 
    <div *ngIf="options.closeButton" class="" title="Close and mark as Read" (click)="readNotification(notificationPackage.config.payload?.notificationId);remove()"><i class="ion ion-md-close-circle-outline"></i></div>
    <div *ngIf="message && message.length > 60" class="" (click)="showMore()"><i class="ion" [ngClass]="'ion-ios-arrow-' + notificationPackage.config.payload?.collapse"></i></div>  
  </div>
</div>

<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>

